
namespace Gamification.Gamification {
    export class UtentiProdottiEsperienzeTaskColumns {
        static columnsKey = 'Gamification.UtentiProdottiEsperienzeTask';
    }
}